import React from "react"

import { Link } from "gatsby"
import * as style from "./QuickStartProgress.module.scss"

const QuickStartProgress = ({ page }) => {
  const percentage = Math.floor((page.stepNumber / page.totalSteps) * 100)

  return (
    <>
      {page.stepPages?.[0] && (
        <div className={style.progress}>
          <header>
            {page.stepPages.map((stepPage) => (
              <Link
                to={stepPage.path}
                key={stepPage.id}
                data-current={stepPage.id === page.id}
                data-past={false}
              >
                {stepPage.stepNumber}
              </Link>
            ))}
          </header>

          <div className={style.progressBar}>
            <span style={{ width: `${percentage}%` }} />
          </div>
        </div>
      )}
    </>
  )
}

export default QuickStartProgress
